<!--编辑简历-工作经验-->
<template>
	<div class="work-experience">

		<h3 class="c-title">工作经历
			<a href="javascript:;" class="btn-add" :class="{'disabled':isEditting||!editable}" @click="callOutAddNewItemModal" v-if="status!=0">
				<i class="icon">
					<img src="../../assets/img/common/icon-add-off.png" v-if="isEditting||!editable"/>
					<img src="../../assets/img/common/icon-add.png" v-else="!isEditting&&editable"/>
				</i>&nbsp;添加
			</a>
		</h3>

		<!--无数据状态-->
		<div class="no-data" v-if="status==0">
			<resume-undone-template blockText="工作经历" :showTitle="false" :editable="editable" v-on:editBtnClick="callOutAddNewItemModal" />
		</div>

		<!--新增项目-->
		<resume-work-modal type="add" :tempObj="tempObj" :show="showAddBox" :resumeId="resumeId" @add-done="addOrEditDone" @add-cancel="addCancel" />

		<!--有数据展示状态-->
		<div class="showBox" v-if="status==1">

			<div class="work-experience-item" v-for="(item,index) in itemList" :key="item.id">
				<!--当前工作经历的展示界面-->
				<div v-if="item.show">
					<div class="item-caption">
						<span>{{item.company}}</span>
						<span class="job-title" :title="item.jobName">{{item.jobTitle}}</span>
						<div class="operation-box">
							<a href="javascript:;" class="operation operation-edit" :class="{'disabled':isEditting||!editable}" @click="editCurrentItem(index)">
								<i class="icon icon-pencil">
									<img src="../../assets/img/common/icon-pencil.png" v-if="!isEditting&&editable"/>
									<img src="../../assets/img/common/icon-pencil-off.png" v-else="isEditting||!editable"/>
								</i>
								<span>编辑</span>
							</a>
							<a href="javascript:;" class="operation operation-delete" :class="{'disabled':isEditting||!editable}" @click="deleteResumeWorkExperience(item.id)">
								<i class="icon icon-pencil">
									<img src="../../assets/img/common/icon-trash-on.png" v-if="!isEditting&&editable"/>
									<img src="../../assets/img/common/icon-trash-off.png" v-else="isEditting||!editable"/>
								</i>
								<span>删除</span>
							</a>
						</div>
					</div>

					<div class="item-duty">
						<div class="item-duty-title">
							<h4>工作内容：<span class="item-duty-endtime">{{item.dateFromStr}}-{{item.isCurrent?"至今":item.dateToStr}}</span></h4>
							<div class="item-duty-description" v-html="item.description"></div>
						</div>
					</div>
				</div>

				<!--编辑现有项目-->
				<resume-work-modal v-if="!item.show" type="edit" :tempObj="item" :show="!item.show" :resumeId="resumeId" @edit-done="addOrEditDone" @edit-cancel="editCancel(index)" />

			</div>
		</div>

	</div>
</template>

<script>
	import ResumeUndoneTemplate from '@/components/EditResume/ResumeUndoneTemplate.vue'
	import ResumeWorkModal from '@/components/EditResume/ResumeWorkModal.vue'

	//1.获取工作经历 2.删除现有工作经历
	import { httpResumeWorkExperienceGet, httpResumeWorkExperienceDelete } from '@/api/resume'

	export default {
		name: 'ResumeWorkExperience',
		components: {
			ResumeUndoneTemplate,
			ResumeWorkModal
		},
		props: {
			orderid: {
				required: true
			},
			resumeId: {
				required: true
			},
			editable: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				status: 0, //0-没资料，1-编辑完成，2-编辑中
				showAddBox: false, //打开新增窗口
				isEditting: false, //指示是否当前是否正在编辑
				itemList: [],
				tempObj: {
					id: 0,
					company: '',
					industryId: '',
					industryInfo: {},
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					occupationId: '',
					occupationInfo: {},
					jobTitle: '',
					description: ""
				},
			}
		},
		mounted() {
			setTimeout(() => this.getResumeWorkExperience(), 40);
		},
		methods: {

			//呼出新增功能窗
			callOutAddNewItemModal() {
				if(this.isEditting || !this.editable) return;
				this.showAddBox = true;
				this.isEditting = true;
				this.$emit('set-edit-status',1);
				this.status = 1;
			},

			//编辑现有项目
			editCurrentItem(index) {
				if(this.isEditting || !this.editable) return;
				this.itemList[index].show = false;
				this.isEditting = true;
			},

			//取消对现有项目的编辑
			editCancel(index) {
				this.isEditting = false;
				this.itemList[index].show = true;
				this.$emit('set-edit-status',2);
			},

			//当在编辑页面完成保存操作后（无论新增还是编辑）
			addOrEditDone() {
				this.getResumeWorkExperience();
				this.status = 1;
				this.showAddBox = false;
				this.isEditting = false;
				this.$emit('set-edit-status',2);
			},

			//当模板页面取消操作之后
			addCancel() {
				this.showAddBox = false;
				this.isEditting = false;
				if(this.itemList.length == 0) {
					this.status = 0;
				}
				this.$emit('set-edit-status',2);
			},

			//删除现有项目经历	
			deleteResumeWorkExperience(id) {
				if(this.isEditting || !this.editable) return;
				let oData = {
					ids: [id],
				}
				httpResumeWorkExperienceDelete(oData).then(r => {
					console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '删除成功',
							duration: 500,
							onClose: () => {
								this.getResumeWorkExperience();
							}
						});
						this.showAddBox = false;
						this.isEditting = false;
					} else {
						this.$message.error("删除失败，请稍后再试");
					}

				}).catch(err => {
					this.$message.error("删除失败，请稍后再试");
				});
			},

			//获取工作经历
			getResumeWorkExperience() {
				let prama = this.resumeId;
				httpResumeWorkExperienceGet(prama).then(r => {
					//console.log(r);
					if(r.success) {
						this.itemList = r.data;
						this.itemList.forEach(item => {
							this.$set(item, 'show', true);
						});
						if(this.itemList.length == 0) {
							this.status = 0;
						} else {
							this.status = 1;
						}
					} else {
						this.$notify({
							title: '警告',
							message: '获取简历工作经历失败',
							type: 'warning'
						});
					}
				}).catch(err => {
					this.$notify({
						title: '警告',
						message: '获取简历工作经历失败',
						type: 'warning'
					});
				})
			}

		} //methods结束标记
	}
</script>
<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
	.work-experience {
		margin-bottom: 30px;
	}
	
	.work-experience-complete {
		margin-top: 30px;
	}
	
	.work-experience-item {
		padding-bottom: 30px;
		margin-bottom: 30px;
		border-bottom: 1px solid #eee;
	}
	
	.item-caption {
		position: relative;
		margin-bottom: 14px;
		font-size: 16px;
		color: #333;
		.job-title {
			display: inline-block;
			max-width: 110px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 14px;
			margin-left: 19px;
			vertical-align: sub;
		}
	}
	
	.item-duty-title {
		font-size: 14px;
		color: #333;
		h4 {
			font-weight: bold;
			line-height: 34px;
		}
		.item-duty-endtime {
			float: right;
			color: #999;
		}
		.item-duty-description {
			color: #666;
			line-height: 34px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeWorkExperience.vue